import React from 'react';
import colors from '../../../colors';
import styled from 'react-emotion';

const Line = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	font-size: 0.875rem;
	margin-bottom: 1.25rem;
`;

const Bar = styled.div`
	background: #f2f2f2;
	flex: 1 0 1px;
	height: 1rem;
	position: relative;
`;

const Progress = styled.div`
	background: #888;
	bottom: 0;
	left: 0;
	position: absolute;
	top: 0;
	width: 0;
`;

const ProgressBack = styled(Progress)`
	width: 100%;
	background-color: #e0e0e0;
`;

export default (props) => {
	const value = props.getValue(props);
	const relative = props.max ? (value / props.max) * 100 : 0;

	return (
		<Line>
			<Bar>
				<ProgressBack>
					<Progress
						style={{ width: relative + '%', backgroundColor: colors[props.id] || colors.default }}
					/>
				</ProgressBack>
			</Bar>
		</Line>
	);
};
